import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import { bindActionCreators } from "redux";
import CSVReader from 'react-csv-reader';
import _ from 'lodash';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactDataGrid from "react-data-grid";
import moment from 'moment';
import Uppy from '@uppy/core';
import Url from "@uppy/url";
import uuidv4 from "uuid/v4";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import DeleteConfirmForm from "../../components/settings/DeleteConfirmForm";
import TemplateCSV from "../../assets/contentcamel-import-template.csv";
import { addEventNameToEndpoint } from "../../utils/common";

import {
  Card,
  Col,
  Row,
  Table,
  Button,
  Alert,
  ProgressBar
} from "react-bootstrap";
import {
  addContentTypes,
  addFunnelStages,
  addContentTag,
  addContentProducts,
  addContentIndustries,
  addContentRegions,
  fetchSettings
} from '../../actions/settings';
import { getImportHistory, createImportHistory, updateHistoryStatus, deleteImportHistory } from '../../actions/items';
import './BulkImport.scss';

const ReactSwal = withReactContent(Swal);

const sampleHeader = [
  'url',
  'title',
  'content type',
  'funnel stage',
  'tags',
  'product',
  'industry',
  'region',
  'internal positioning',
  'public description',
  'status'
];

const IMPORT_STATUS = {
  INPROCESS: "INPROCESS",
  COMPLETED: "COMPLETED",
  DELETED: "DELETED",
  DELETE_FAIL: "DELETE FAIL"
}

const CC_COMPANION_URL = process.env.REACT_APP_COMPANION_URL; // "http://localhost:3020"

// Get string without HTTP protocol and last slash
const getShortendUrl = (url) => {
  let updatedUrl = url.replace('https://', '');
  updatedUrl = updatedUrl.replace('http://', '');
  updatedUrl = updatedUrl.toLowerCase();
  const lastCharacter = updatedUrl.slice(updatedUrl.length - 1, updatedUrl.length);

  if (lastCharacter === '/') {
    updatedUrl = updatedUrl.slice(0, updatedUrl.length - 1);
  }

  return updatedUrl;
}

/**
 * OVERRIDE for Uppy URL getFileNameFromUrl
 * Note: this is to prevent false duplicates due to bad parsing
 * @see https://github.com/transloadit/uppy/blob/56e7f83269125f5a4e7d91ea7d0e3a4ba5fbaec4/packages/%40uppy/url/src/index.js
 * @param {String} url 
 * @returns 
 */
const getFileNameFromUrl = (url) => {
  return url;
}

class BulkImport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      importData: [],
      filename: null,
      dataRows: [],
      columns: [],
      isConfirming: false,
      isUploading: false,
      loadCSVError: false,
      successFileUrls: [],
      failFileCounts: 0,
      uploadedItemCounts: 0,
      availableUrls: [],
      newContentTags: {},
      importId: null
    };

    this.initHistoryObj = {
      createdContentTypes: [],
      createdFunnelStages: [],
      createdTags: [],
      createdContentProducts: [],
      createdContentIndustries: [],
      createdContentRegions: [],
      assemblyIds: [],
      itemsIds: [],
      files: [],
    }

    this.tenantId = _.get(this.props, 'user.tenantId', '');
    this.userId = _.get(this.props, 'cognitoUser.username', _.get(this.props, 'cognitoUser.username', ''));

    // Uppy integrations
    this.uppy = new Uppy({
      id: 'uppyBulkImport',
      debug: false,
      autoProceed: false,
      // restrictions: {
      //   minNumberOfFiles: 1,
      // },
      meta: {
        tenantId: this.tenantId,
        userId: _.get(this.props, 'cognitoUser.username', _.get(this.props, 'cognitoUser.username', '')), 
        // importId: this.importId
      },
      onBeforeUpload: (files) => {
        return true;
      }
    })
    .use(Url, { companionUrl: CC_COMPANION_URL });

    // ////////////////////////////////////////////////////////////////
    // Uppy Lifecycle events

    /**
     * Restriction Failed
     * info on any restriction mismatches
     */
    this.uppy.on('restriction-failed', (file, error) => {
      console.error({info: "restriction-failed", file, error});
    })

    /**
     * Info Visible.
     * All events settled, so final UI updates can occur
     */
    this.uppy.on('info-visible', (info) => {
      // console.log({failCount: this.state.failFileCounts, info: "info-visible"});
      const failFileCounts = this.state.failFileCounts + 1;
      this.setState({ failFileCounts });

      if ((this.uppy.getFiles().length + failFileCounts) === this.state.availableUrls.length) {
        toast.error(`Errors found with ${failFileCounts} Urls`, {
          position: toast.POSITION.TOP_RIGHT
        });
        const { dataRows } = this.state;
        dataRows.forEach((row, index) => {
          if (_.isEmpty(row['status'])) {
          }

          if (row['status'] === 'Valid Url') {
            if (this.state.successFileUrls.find(url => getShortendUrl(row['c_0']) === getShortendUrl(url))) {
              dataRows[index]['status'] = 'Duplicated Url';
            } else {
              dataRows[index]['status'] = 'Invalid Url';
            }
          }
        });

        this.setState({ dataRows: [ ...dataRows ] });
      }
    });

    /**
     * File added
     * We assign metadata and update UI with status of import URL
     */
    this.uppy.on('file-added', (newFile) => {
      const { dataRows } = this.state;
      const rowIndex = dataRows.findIndex(r => getShortendUrl(newFile.remote.body.url) === getShortendUrl(r['c_0']));
      const tags = (dataRows[rowIndex]['c_4'] || '').split(',').map(tag => tag.trim());

      // set metadata on file
      const rowMeta = {
        source: dataRows[rowIndex]['c_0'] || '',
        contentTitle: dataRows[rowIndex]['c_1'] || '',
        contentType: dataRows[rowIndex]['c_2'] || '',
        funnelStage: dataRows[rowIndex]['c_3'] || '',
        contentTags: tags,
        contentProduct: dataRows[rowIndex]['c_5'] || '',
        contentIndustry: dataRows[rowIndex]['c_6'] || '',
        contentRegion: dataRows[rowIndex]['c_7'] || '',
        contentPositioning: dataRows[rowIndex]['c_8'] || '',
        contentDescription: dataRows[rowIndex]['c_9'] || '',
      }
      
      this.uppy.setFileMeta(newFile.id, rowMeta);

      if (rowIndex >= 0) {
        let newRow = {};
        Object.assign(newRow, dataRows[rowIndex]);
        newRow['status'] = 'Correct Url';

        if (newFile.type.includes('text/html')) {
          this.props.items.forEach(item => {
            if (item.ext === 'html' && item.urls.source === newFile.remote.body.url) {
              newRow['status'] = 'Already exists';
              return;
            }
          });
        } else {
          this.props.items.forEach(item => {
            if (item.ext !== 'html' && item.name === newFile.name) {
              newRow['status'] = 'Already exists';
              return;
            }
          });
        }

        dataRows[rowIndex] = newRow;
      }

      // if ((this.uppy.getFiles().length + this.state.failFileCounts) === dataRows.length) {
      if (((this.state.successFileUrls.length + 1)  + this.state.failFileCounts) === this.state.availableUrls.length) {
        dataRows.forEach((row, index) => {
          let newRow = {};
          if (row) {
            Object.assign(newRow, row);
          } else {
            Object.assign(newRow, {});
          }
          
          if (_.isEmpty(row['status'])) {
            if (this.state.successFileUrls.find(url => getShortendUrl(row['c_0']) === getShortendUrl(url))) {
              newRow['status'] = 'Duplicated Url';
            } else {
              newRow['status'] = 'Bad Url';
            }

            dataRows[index] = newRow;
          }

          if (row['status'] === 'Valid Url') {
            if (this.state.successFileUrls.find(url => getShortendUrl(row['c_0']) === getShortendUrl(url))) {
              newRow['status'] = 'Duplicated Url';
            } else {
              newRow['status'] = 'Invalid Url';
              // console.log({failCount: this.state.failFileCounts})
            }

            dataRows[index] = newRow;
          }
        });

        if (this.state.failFileCounts > 0) {
          toast.error(`Errors found with ${this.state.failFileCounts} Urls`, {
            position: toast.POSITION.TOP_RIGHT
          });
        }
      }

      const { successFileUrls } = this.state;
      successFileUrls.push(newFile.remote.body.url);

      this.setState({ dataRows: [ ...dataRows ], successFileUrls });
    });

    /**
     * Assembly created
     */
    this.uppy.on('transloadit:assembly-created', (assembly, fileIDs) => {
      // console.log('Created assembly', assembly.assembly_id, 'for file count:', fileIDs.length);
    });

    /**
     * Upload Error
     */
    this.uppy.on('upload-error', (file, error, response) => {
    });

    /**
     * Upload success
     */
    this.uppy.on('upload-success', (file, response) => {
      this.setState({ uploadedItemCounts: this.state.uploadedItemCounts + 1 });
      // console.log({file: file, info: "upload-success"});
    })

    /**
     * Complete
     */
    this.uppy.on('complete', result => {
      this.completeImport();
      this.uppy.unmount();
    });
  }

  completeImport = async () => {
    this.setState({ isUploading: false });
    const completedImportId = this.state.importId;
    // reset
    this.setState({
      importData: [],
      filename: null,
      dataRows: [],
      columns: [],
      isConfirming: false,
      isUploading: false,
      successFileUrls: [],
      failFileCounts: 0,
      uploadedItemCounts: 0,
      newContentTags: {},
      importId: null
    });
    
    await this.props.updateHistoryStatus(IMPORT_STATUS.COMPLETED, completedImportId);
    await this.props.getImportHistory();
    await this.props.fetchSettings();
  }
  // ////////////////////////////////////////////////////////////////
  // 

  componentDidMount() {
    // From willMount
    this.props.getImportHistory();
  }

  RowRenderer = ({ renderBaseRow, ...props }) => {
    let style = 'default-status';
    
    switch (props.row.status) {
      case 'Correct Url':
        style = 'correct-status';
        break;
      case 'Bad Url':
      case 'Missing URL':
      case 'Missing title':
        style = 'error-status'
        break;
      case 'Duplicated Url':
      case 'Already exists':
        style = 'warning-status';
        break;
      default:
        style = 'default-status';
        break;
    }

    return <div className={style}>{renderBaseRow(props)}</div>;
  };

  /**
   * Load a new csv file for import
   * @param {Object} result 
   * @param {Object} file 
   * @returns 
   */
  onFileLoad = (result, file) => {
    this.uppy.cancelAll({reason: 'onFileLoad'});
    this.setState({ failFileCounts: 0 });
    // set a new import id
    const importId = uuidv4();
    this.setState({importId});

    this.uppy.setMeta({
      userId: this.userId,
      tenantId: this.tenantId,
      importId
    });

    const headerTitles = [ ...result[0], 'status' ];
    if (!_.isEqual(headerTitles, sampleHeader)) {
      toast.error('Failed to import CSV: Template does not match.', {
        position: toast.POSITION.TOP_RIGHT
      });

      return;
    }
    
    let isLoadCSVError = false;

    const dataRows = result
      .filter((data, index) => {
        if (index === 0) {
          return false;
        } else if (index === result.length - 1) {
          let emptyStatus = true;
          
          data.forEach((dd, idx) => {
            if (dd && dd !== '' && dd !== '\n') {
              emptyStatus = false;
            }
          });

          if (emptyStatus) {
            return false;
          }
        }

        return true;
      })
      .map((data, index) => {

        let dataFields  = {};

        // Set default status for rows
        if (!data[0] || data[0] === '') {
          isLoadCSVError = true;
          dataFields['status'] = 'Missing URL';
        } else if (!data[1] || data[1] === '') {
          isLoadCSVError = true;
          dataFields['status'] = 'Missing title';
        } else {
          dataFields['status'] = 'Valid Url';
        }
        
        data.forEach((dd, idx) => {
          dataFields[`c_${idx}`] = dd;
        });
        dataFields['id'] = `r_${index}`;

        return dataFields;
      });

    const columns = result[0].map((data, index) => ({ key: `c_${index}`, name: data, editable: false, resizable: true }));
    columns.push({
      key: 'status',
      name: 'Status',
      editable: false,
      resizable: true
    });

    this.historyObj = this.initHistoryObj;
    this.historyObj.filename = file;
    const availableUrls = [];

    if (!isLoadCSVError) {
      dataRows
        .filter(row => row['c_0'] && row['c_1'])
        .forEach(row => {
          const lastChar = row['c_0'][row['c_0'].length - 1];
          let fileUrl = row['c_0'];
          if (lastChar === '/') {
            fileUrl = fileUrl.slice(0, row['c_0'].length - 1);
          }

          try {
            if (!availableUrls.includes(fileUrl)) {
              availableUrls.push(fileUrl);
              this.setState({ availableUrls });
              // override handling of url file name
              // to prevent false duplicates
              this.uppy.getPlugin('Url').getFileNameFromUrl = getFileNameFromUrl;
              this.uppy.getPlugin('Url').addFile(fileUrl);
            }
          } catch (err) {
          }
        });
    }
    
    this.setState({
      importData: result,
      dataRows,
      filename: file,
      columns: columns,
      successFileUrls: [],
      loadCSVError: isLoadCSVError,
      importId
    });
  }

  onHandleError = (error) => {
    toast.error('Failed to import CSV: ' + error.message, {
      position: toast.POSITION.TOP_RIGHT
    });
  }

  onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    
    this.setState(state => {
      const rows = state.dataRows.slice();
      for (let i = fromRow; i <= toRow; i++) {
        rows[i] = { ...rows[i], ...updated };
      }
      return { dataRows: rows };
    });
  };

  /**
   * Adding new tags is tricky because of the timing. We add tags to local state
   * and also push to be added on backend.
   * 
   * Note: we do no checking in this method on current tag state
   * @param {Object} newTag 
   */
  addNewContentTag = async (newTag) => {
    const { name } = newTag;
    
    this.historyObj.createdTags.push(name);
    this.props.addContentTag(newTag);

    this.state.newContentTags[name] = {
      sort: newTag.sort,
      color: newTag.color,
      importId: newTag.importId || null
    };
  }

  /**
   * Process the datatable on import
   */
  processTagsStagesAndTypes = async () => {
    this.state.dataRows.forEach(row => {
      if (row && row['c_0'] && row['c_1']) {
        // Validating meta data
        let errorText = [];
        const {
          contentTypes,
          funnelStages,
          contentTags,
          contentProducts,
          contentIndustries,
          contentRegions
        } = this.props.settings;

        // Check and add content type
        const types = row['c_2']
          .split(",")
          .map(type => type.trim());
        // let selectedType = null;
        if (types.length > 1) {
          errorText.push('You should add only 1 content type');
        } else if (types.length === 1) {
          if (!_.isEmpty(types[0]) && !Object.keys(contentTypes).includes(types[0])) {
            if (!this.historyObj.createdContentTypes.includes(types[0])) {
              this.historyObj.createdContentTypes.push(types[0]);
            }
          }

          // selectedType = types[0];
        }

        // Check and add funnel stage
        const funnels = row['c_3']
          .split(",")
          .map(funnel => funnel.trim());
        // let selectedFunnel = null;
        if (funnels.length > 1) {
          errorText.push('You should add only 1 Funnel stage');
        } else if (funnels.length === 1) {
          if (!_.isEmpty(funnels[0]) && !Object.keys(funnelStages).includes(funnels[0])) {
            if (!this.historyObj.createdFunnelStages.includes(funnels[0])) {
              this.historyObj.createdFunnelStages.push(funnels[0]);
            }
          }

          // selectedFunnel = funnels[0];
        }

        // Check and add content tags
        const tags = row['c_4']
          .split(",")
          .map(tag => tag.trim());
        let selectedTags = {};
        if (tags.length >= 1) {
          tags.forEach((t, index) => {
            if (contentTags[t]) {
              selectedTags[t] = contentTags[t];
            } else if (!_.isEmpty(t)) {
              const generatedColor = `#${Math.round((Math.random() * 255)).toString(16)}${Math.round((Math.random() * 255)).toString(16)}${Math.round((Math.random() * 255)).toString(16)}`;

              if (!this.historyObj.createdTags.includes(t)) {
                const newTag = {
                  originalName: null,
                  name: t,
                  sort: 99,
                  description: '',
                  color: generatedColor,
                  importId: this.state.importId
                };
                this.addNewContentTag(newTag);
              }
            }
          });
        }

        // Check and add content product
        const products = row['c_5']
          .split(",")
          .map(product => product.trim());
        // let selectedFunnel = null;
        if (products.length > 1) {
          errorText.push('You should add only 1 Product');
        } else if (products.length === 1) {
          if (!_.isEmpty(products[0]) && !Object.keys(contentProducts || {}).includes(products[0])) {
            if (!this.historyObj.createdContentProducts.includes(products[0])) {
              this.historyObj.createdContentProducts.push(products[0]);
            }
          }

          // selectedFunnel = funnels[0];
        }

        // Check and add content industry
        const industries = row['c_6']
          .split(",")
          .map(industry => industry.trim());
        // let selectedFunnel = null;
        if (industries.length > 1) {
          errorText.push('You should add only 1 Industry');
        } else if (industries.length === 1) {
          if (!_.isEmpty(industries[0]) && !Object.keys(contentIndustries || {}).includes(industries[0])) {
            if (!this.historyObj.createdContentIndustries.includes(industries[0])) {
              this.historyObj.createdContentIndustries.push(industries[0]);
            }
          }

          // selectedFunnel = funnels[0];
        }

        // Check and add content industry
        const regions = row['c_7']
          .split(",")
          .map(region => region.trim());
        // let selectedFunnel = null;
        if (regions.length > 1) {
          errorText.push('You should add only 1 Region');
        } else if (regions.length === 1) {
          if (!_.isEmpty(regions[0]) && !Object.keys(contentRegions || {}).includes(regions[0])) {
            if (!this.historyObj.createdContentRegions.includes(regions[0])) {
              this.historyObj.createdContentRegions.push(regions[0]);
            }
          }

          // selectedFunnel = funnels[0];
        }

        if (row) {
          // this.uppy.setFileMeta(newFile.id, {
          //   contentTitle: row['c_1'] || '',
          //   contentType: selectedType || '',
          //   funnelStage: selectedFunnel || '',
          //   contentTags: selectedTags || {},
          //   contentDescription: row['c_7'] || ''
          // });
        }
      }
    });
  };

  /**
   * The import event
   */
  onImport = async () => {
    const importId = this.state.importId;
    
    if (this.uppy.getPlugin('Transloadit')) {
      this.uppy.removePlugin(this.uppy.getPlugin('Tus'));
      this.uppy.removePlugin(this.uppy.getPlugin('Transloadit'));
      try {
        this.uppy.unmount();
      } catch (error) {
        console.log(error);
      }
    }

    if (this.uppy.getPlugin('AwsS3Multipart')) {
      this.uppy.removePlugin(this.uppy.getPlugin('AwsS3Multipart'));
      try {
        this.uppy.unmount();
      } catch (error) {
        console.log(error);
      }
    }

    toast.info('Import processing', {
      position: toast.POSITION.TOP_RIGHT
    });

    this.setState({
      successFileUrls: [],
      failFileCounts: 0
    });

    // Create history object for in process import
    this.historyObj.importId = importId;
    this.historyObj.tenantId = this.tenantId;
    this.historyObj.userId = this.userId;

    // process the datatable for import
    await this.processTagsStagesAndTypes();

    // get filtered down list of file data
    try {
      this.historyObj.files = this.uppy.getFiles().map( f => {

        // format tags based on account tags 
        //and any new tags added in this import
        const contentTagKeys = f.meta.contentTags;
        const { contentTags } = this.props.settings;
        const tags = {};

        contentTagKeys.forEach(key => {
          tags[key] = contentTags[key];      
          // add in new tags, because update doesn't seem to fire and be
          // accessible yet (even on refresh)
          if (!tags[key]) {
            tags[key] = this.state.newContentTags[key];
          }
        });

        const importFile = {
          source: f.source,
          id: f.id,
          tenantId: this.tenantId,
          meta: f.meta,
          type: f.type,
          size: f.size,
          userId: this.userId
        }
        importFile.meta.contentTags = tags;
        // console.log({event: "onImport", importFile, tags});
        return importFile;
      });
    } catch (error) {
      console.log(error);
    }

    this.historyObj.status = IMPORT_STATUS.INPROCESS;
    this.setState({ isUploading: true });
    // console.log(this.historyObj);
    // create history and post files to our own endpoint
    await this.props.createImportHistory(this.historyObj);
    const newFunnels = (this.historyObj.createdFunnelStages || []).map(stageName => ({
      name: stageName,
      stage: 99,
      description: '',
      importId
    }));
    await this.props.addFunnelStages(newFunnels);
    const newContentTypes = (this.historyObj.createdContentTypes || []).map(typeName => ({
      name: typeName,
      sort: 99,
      description: '',
      importId
    }));
    await this.props.addContentTypes(newContentTypes);
    const newProducts = (this.historyObj.createdContentProducts || []).map(productName => ({
      name: productName,
      sort: 99,
      description: '',
      importId
    }));
    await this.props.addContentProducts(newProducts);
    const newIndustries = (this.historyObj.createdContentIndustries || []).map(industryName => ({
      name: industryName,
      sort: 99,
      description: '',
      importId
    }));
    await this.props.addContentIndustries(newIndustries);
    const newRegions = (this.historyObj.createdContentRegions || []).map(regionName => ({
      name: regionName,
      sort: 99,
      description: '',
      importId
    }));
    await this.props.addContentRegions(newRegions);
    this.historyObj = this.initHistoryObj;

    addEventNameToEndpoint(this.props.Analytics, 'admin-item-import');
    this.props.Analytics.record({
      name: 'admin-item-import',
      metrics: {
        itemCount: this.state.dataRows.length.toString(),
        userId: _.get(this.props.cognitoUser, 'username', ''),
        filename: this.state.filename
      }
    });

    // we no longer use Uppy uploader plugins here -- we send history files as json
    // to s3
    // this.uppy.upload();
    // this.setState({ isUploading: true });
    
    await this.completeImport();
    
    this.setState({
      importData: [],
      isConfirming: false,
      failFileCounts: 0,
      successFileUrls: []
    });
  }

  onConfirm = () => {
    const { columns } = this.state;

    const newColumns = columns.map(col => ({ ...col, editable: true, resizable: true }));
    this.setState({ isConfirming: true, columns: newColumns });
  }

  onCancelImport = () => {
    const { columns } = this.state;
    
    const newColumns = columns.map(col => ({ ...col, editable: true, resizable: true }));
    this.setState({
      isConfirming: false,
      columns: newColumns,
      isFetchCompleted: false,
      filename: null,
      failFileCounts: 0,
      successFileUrls: [],
      dataRows: [],
      loadCSVError: false,
      newContentTags: {},
      importId: null
    });

    this.historyObj = { ...this.initHistoryObj };
    this.uppy.cancelAll({reason: 'onCancelImport'});
  }

  onDeleteHistory = (importId) => {
    const deleteHistory = this.props.histories.find(history => history.importId === importId);
    if (deleteHistory) {
      this.handleDeleteSettings(deleteHistory);
    }
  }

  handleDeleteSettings = (history) => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <DeleteConfirmForm
          type='importHistory'
          filename={history.filename}
          onClose={ReactSwal.clickCancel}
          onConfirm={ReactSwal.clickConfirm}
        />
      )
    })
    .then(result => {
      if (result.value) {
        addEventNameToEndpoint(this.props.Analytics, 'admin-delete-import-history');
        this.props.Analytics.record({name: 'admin-delete-import-history', attributes: { importId: history.importId }});
        this.props.deleteImportHistory(history.importId);
      }
    });
  }

  render() {
    const { isUploading, loadCSVError } = this.state;
    const isFetchCompleted = (this.state.successFileUrls.length + this.state.failFileCounts === this.state.availableUrls.length);

    return (
      <div className="bulk-import-container">
        <Row className="full-width">
          <Col>
            <Row className="full-width">
              <Card bg="light" className="full-width full-height">
                <Card.Header>
                  <div className="import-card-header">
                    Import CSV
                    {this.state.filename && isFetchCompleted && 
                      <div>
                        {this.state.isConfirming && <span className="confirm-text mr-2">{this.state.dataRows.length} records will be imported, ok?</span>}
                        {(this.state.failFileCounts || this.state.isConfirming || loadCSVError) && <Button variant="outline-danger" size="sm" className="mr-2" onClick={this.onCancelImport}>CANCEL</Button>}
                        {this.state.isConfirming && <Button variant="outline-danger" size="sm" onClick={this.onImport}>OK</Button>}
                        {!this.state.isConfirming && (this.state.failFileCounts === 0) && !loadCSVError && <Button variant="outline-danger" size="sm" onClick={this.onConfirm}>IMPORT</Button>}
                        {/* {!this.state.isConfirming && <Button variant="outline-danger" size="sm" onClick={this.onConfirm}>IMPORT</Button>} */}
                      </div>
                    }
                  </div>
                </Card.Header>
                <Card.Body>
                  {this.state.filename ?
                      <div>
                        {!isUploading && !isFetchCompleted &&
                          <ProgressBar
                            className="mb-2"
                            animated
                            now={(this.state.successFileUrls.length + this.state.failFileCounts) / this.state.availableUrls.length * 100}
                            label={`Checking(${((this.state.successFileUrls.length + this.state.failFileCounts) / this.state.availableUrls.length * 100).toFixed(2)}%)`}
                          />
                        }
                        {isUploading &&
                          <ProgressBar
                            className="mb-2"
                            striped
                            variant="danger"
                            animated
                            now={this.state.uploadedItemCounts / this.uppy.getFiles().length * 100}
                            label={`Uploading(${(this.state.uploadedItemCounts / this.uppy.getFiles().length * 100).toFixed(2)}%)`}
                          />
                        }
                        {isFetchCompleted && this.state.failFileCounts > 0 &&
                          <CSVReader
                            cssClass="csv-reader-input mb-2"
                            label="Select your content items (CSV) to upload."
                            onFileLoaded={this.onFileLoad}
                            onError={this.onHandleError}
                            inputId="csvInput"
                            inputStyle={{ color: 'red' }}
                          />
                        }
                        <ReactDataGrid
                          columns={this.state.columns}
                          rowGetter={i => this.state.dataRows[i]}
                          rowsCount={this.state.dataRows.length}
                          onGridRowsUpdated={this.onGridRowsUpdated}
                          enableCellSelect={true}
                          rowRenderer={this.RowRenderer}
                        />
                      </div>
                    : <div>
                      <CSVReader
                        cssClass="csv-reader-input"
                        label="Select your content items (CSV) to upload."
                        onFileLoaded={this.onFileLoad}
                        onError={this.onHandleError}
                        inputId="csvInput"
                        inputStyle={{ color: 'red' }}
                      />
                      <div className="mt-2">
                        <Alert variant="info">
                          Currently import is only supported in our template format<br/>
                          <FontAwesomeIcon className="mr-2" icon={faDownload} />
                          <a href={TemplateCSV} download>Download an import template</a>
                        </Alert>
                      </div>
                    </div>
                  }
                </Card.Body>
              </Card>
            </Row>
            {!this.state.filename &&
              <Row className="full-width">
                <Card bg="light" className="full-width full-height">
                  <Card.Header>Import History</Card.Header>
                  <Card.Body>
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th width="20%">Date</th>
                          <th width="40%">Filename</th>
                          <th width="20%">Status</th>
                          <th width="20%">Status Details</th>
                          <th width="20%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.histories.map((data, index) => 
                          <tr key={index}>
                            <td>{moment(data.createdAt).format('YYYY-MM-DD HH:mm:ss')}</td>
                            <td>{data.filename}</td>
                            <td>{data.status}</td>
                            <td>{data.statusDetails}</td>
                            <td>
                              {(data.status !== IMPORT_STATUS.DELETED && data.status !== IMPORT_STATUS.DELETE_FAIL) &&
                                <Button variant="outline-danger" size="sm" onClick={() => this.onDeleteHistory(data.importId)}>DELETE</Button>}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {this.props.histories.length === 0 && <div className="no-content">No content has been imported yet</div>}
                  </Card.Body>
                </Card>
              </Row>
            }
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  Analytics: state.auth.Analytics,
  Auth: state.auth.Auth,
  user: state.auth.tenant,
  cognitoUser: state.auth.cognitoUser,
  accessToken: state.auth.cognitoUser ? state.auth.cognitoUser.signInUserSession.accessToken.jwtToken : null,
  settings: state.settings,
  histories: state.item.importHistory || [],
  items: state.item.items
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  addContentTypes,
  addFunnelStages,
  addContentTag,
  getImportHistory,
  createImportHistory,
  updateHistoryStatus,
  deleteImportHistory,
  addContentProducts,
  addContentIndustries,
  addContentRegions,
  fetchSettings
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BulkImport);
